import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(app)/community/page.tsx");
